module.exports = __webpack_public_path__ + "img/SC.f70f07cb.png";